<template>
    <section class="quiz__campaign-question" :class="{ 'quiz__campaign-question-active' : active_question }">
        <div class="quiz__campaign-question-block">
            <p class="quiz__campaign-question-text">{{ question.content }}</p>
        </div>
        <div class="quiz__campaign-answers" :class="{ 'quiz__campaign-answers-balanced' : (answersAmount == 2) }">
            <answer :question="question.id" :answer="answer" v-for="(answer, key) in question.answers" :answer_given="answer_given" :key="'answer_'+key"></answer>
        </div>
        <a @click.prevent="updateQuestionVisibility(next_question)" href="#" class="quiz__campaign-next quiz__campaign-button" :class="{ 'quiz__campaign-next-active' : answer_given }">Next</a>
    </section>
</template>
<script>
import Answer from './answer';
export default {
    props: ['question','index'],
    components: {
        Answer
    },
    computed: {
        answersAmount: function(){
            return this.question.answers.length;
        },
        // answersAmount: function(){
        //     var array = question.endpoint_key.split(',')

        //     return this.question.answers.length;
        // }
    },
    methods : {
        updateQuestionVisibility( question = null )
        {
            Event.$emit('question_moving', { next_question : question.id });
        },
        getNextQuestion( question, answer ) {
            $.ajax('/quiz-campaign/next/'+ question + '/' + answer, {
                method: 'GET',
                success: function(response, textStatus, xhr) {
                    this.next_question = response;
                },
                error: function(xhr, textStatus, string) {
                    console.log(string);
                }
            });
        }
    },
    created() {
        Event.$on('start_quiz', ($event) => (this.active_question = (this.index==0) ? true : false));
        Event.$on('question_'+ this.question.id +'_answered', ($event) => (this.answer_given = true) );
        Event.$on('question_'+ this.question.id +'_answered', ($event) => ( this.getNextQuestion( this.question.id, $event.active_id ) ) );
        Event.$on('question_moving', ($event) => ( this.active_question = (this.question.id == $event.next_question ) ? true : false ));
    },
    mounted (){
        //this.active_question = (this.index==0) ? true : false;
    },
    data() {
        return {
            answer_given: false,
            active_question: false,
            next_question: null
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/question.vue